import React from 'react'
import { ArrowRightOutlined, RobotOutlined } from '@ant-design/icons'
import { useFormContext } from '@/state/main-form/reducer'
import { toggleShowLlmMemoryField } from '@/state/user-interface'
import { SITE_NAME } from '@/utils/constants'
import { useAppDispatch } from '@/utils/hooks'
import style from './top-bar.module.sass'
import { useGlobalContext } from '@/components/context'

type Props = {
	setChatOpen: (chatOpen: boolean) => void
}

export const TopBar = ({ setChatOpen }: Props) => {
	const formContext = useFormContext()
	const dispatch = useAppDispatch()
	const globalContext = useGlobalContext()
	const isAdmin = globalContext.user.isAdmin

	return (
		<div className={style.container}>
			<div className={style.leftContent}>
				<div className={style.agentLogo} style={{ cursor: isAdmin ? 'pointer' : 'default' }} onClick={() => isAdmin && dispatch(toggleShowLlmMemoryField())}>
					<RobotOutlined />
				</div>
				<div className={style.nameContainer}>
					<div className={style.agentName}>
						{SITE_NAME.charAt(0).toUpperCase() + SITE_NAME.slice(1).toLowerCase()} Assistant
					</div>
					<div className={style.description}>{formContext.form.title}</div>
				</div>
			</div>

			<div className={style.closeButton} onClick={() => setChatOpen(false)}>
				<ArrowRightOutlined />
			</div>
		</div>
	)
}
